import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

/**
 * DetailRow - Renders a labeled data row with an icon
 * Used for displaying order, patient, and appointment details
 */
export const DetailRow = ({ icon, label, value, hasCheckIcon = false, iconColor = '#1890ff' }) => {
    if (!value || value === '---' || value === '') return null;

    return (
        <div className="d-flex align-items-start mb-3">
            <div style={{ marginRight: '12px', color: iconColor }}>
                <FeatherIcon icon={icon} size={18} />
            </div>
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', color: '#8c8c8c', marginBottom: '4px' }}>{label}</div>
                <div className="d-flex align-items-center">
                    {hasCheckIcon && (
                        <FeatherIcon icon="check-circle" size={16} className="me-2" style={{ color: '#52c41a' }} />
                    )}
                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#262626' }}>{value}</span>
                </div>
            </div>
        </div>
    );
};

/**
 * PaymentStatusRow - Specific row for payment status with green icon
 */
export const PaymentStatusRow = ({ icon, label, value, hasCheckIcon = false }) => {
    return <DetailRow icon={icon} label={label} value={value} hasCheckIcon={hasCheckIcon} iconColor="#52c41a" />;
};
